import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ChatImageProps} from "@/services/models/chat-image";

interface PendingMessageState {
    message: string;
    agent: string;
    chatId: string;
    isPending: boolean;
    files?: ChatImageProps[];
}

const initialState: PendingMessageState = {
    message: '',
    agent: '',
    chatId: '',
    isPending: false,
    files: []
};

export const pendingMessageSlice = createSlice({
    name: "pendingMessage",
    initialState,
    reducers: (create) => ({
        setPendingMessage: create.reducer(
            (state, action: PayloadAction<{
                message: string;
                agent: string;
                chatId: string,
                files?: ChatImageProps[]
            }>) => {
                state.message = action.payload.message;
                state.agent = action.payload.agent;
                state.chatId = action.payload.chatId;
                state.isPending = true;
                state.files = action.payload.files;
            }
        ),
        clearPendingMessage: create.reducer((state) => {
            state.message = '';
            state.agent = '';
            state.chatId = '';
            state.isPending = false;
            state.files = [];
        }),
    })
});

export const pendingMessageSliceActions = pendingMessageSlice.actions;
export default pendingMessageSlice;